import React, { useRef, useCallback, useLayoutEffect } from 'react';
import classNames from 'classnames';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var Textarea = function Textarea(_a) {
  var _b = _a.disabled,
    disabled = _b === void 0 ? false : _b,
    _c = _a.autoSize,
    autoSize = _c === void 0 ? false : _c,
    onChange = _a.onChange,
    otherProps = __rest(_a, ["disabled", "autoSize", "onChange"]);
  var ref = useRef(null);
  var cssClasses = classNames(["p-md", getBorderClasses(disabled), getTextClasses(disabled), "resize-none", "lg:leading-125 bg-light", "focus:outline-none", "w-full"]);
  var resizeTextArea = useCallback(function () {
    if (autoSize && ref.current) {
      ref.current.style.setProperty("height", "auto");
      ref.current.style.setProperty("height", "".concat(ref.current.scrollHeight, "px"));
    }
  }, [autoSize]);
  var handleOnChange = function handleOnChange(event) {
    resizeTextArea();
    if (onChange) onChange(event);
  };
  useLayoutEffect(function () {
    resizeTextArea();
  }, [resizeTextArea]);
  return /*#__PURE__*/React.createElement("textarea", __assign({
    ref: ref,
    className: cssClasses,
    style: {
      minHeight: 80,
      maxHeight: "20rem"
    },
    disabled: disabled,
    onChange: handleOnChange
  }, otherProps));
};
function getBorderClasses(disabled) {
  if (disabled) {
    return getBaseBorderClasses();
  }
  return "".concat(getBaseBorderClasses(), " hover:border-dark focus:border-darkest");
}
function getBaseBorderClasses() {
  return "border border-solid border-transparent rounded-base";
}
function getTextClasses(disabled) {
  return ["text-sm font-normal text-secondary", {
    "text-muted": disabled
  }];
}
Textarea.displayName = "Textarea";

export { Textarea };
//# sourceMappingURL=index.es.js.map
